module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-4.e0b640e0.jpg";